"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toNotationSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toNotationSlice = function (data, logger) {
    var notations_title = fields_1.toText(data.primary.notations_title);
    var notations = data.items
        .map(function (item) { return toNotationItem(item, logger); })
        .filter(Boolean);
    // Test des champs obligatoires
    if (!(notations_title && (notations === null || notations === void 0 ? void 0 : notations.length))) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Notation)), { notations_title: notations_title,
        notations: notations }));
};
exports.toNotationSlice = toNotationSlice;
var toNotationItem = function (data, logger) {
    // Test des champs obligatoires
    var image = logger.required(fields_1.toImage(data.image, logger));
    if (!image) {
        return undefined;
    }
    var title = fields_1.toText(data.doc_title);
    var link = fields_1.toMediaLink(data.doc_link, logger);
    if ((title && !link) || (link && !title)) {
        return undefined;
    }
    var image_link = fields_1.toLink(data.image_link, logger);
    var long_term = fields_1.toText(data.long_term);
    var short_term = fields_1.toText(data.short_term);
    var outlook = fields_1.toText(data.outlook);
    var last_revision = fields_1.toText(data.last_revision);
    var document = utils_1.compact({
        title: title,
        link: link
    });
    return utils_1.compact({
        image: image,
        image_link: image_link,
        long_term: long_term,
        short_term: short_term,
        outlook: outlook,
        last_revision: last_revision,
        document: document
    });
};
//# sourceMappingURL=notation-slice.js.map